import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { spaceXL } from '@xing-com/tokens';

export const PaginationButtonLayout = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: ${spaceXL};
`;

export const PaginationButton = styled(Button)`
  margin: ${spaceXL};
`;
